<template>
  <div class="terms-of-service">
    <StaticPagesHeader class="header"></StaticPagesHeader>
    <div class="container content-wrapper">
      <h1 class="title">{{ $t(`termsOfService.title`) }}</h1>
      <div class="download-link">
        <a
          class="download-link"
          target="_blank"
          v-bind:href="$t(`termsOfService.ressourceUrl`)"
        >
          {{ $t(`message.downloadInPdf`) }}
        </a>
      </div>
      <div class="columns">
        <div class="left-column">
          <div
            v-for="(section, index) in sections"
            :key="index"
            v-bind:id="section.key"
          >
            <StyledParagraph
              v-bind:title="section.title"
              v-bind:paragraphs="section.paragraphs"
            />
          </div>
        </div>
        <MenuFixed v-bind:links="links" />
      </div>
    </div>
  </div>
</template>

<script>
import StaticPagesHeader from "@/components/staticpages/StaticPagesHeader";
import StyledParagraph from "@/components/staticpages/StyledParagraph";
import MenuFixed from "@/components/staticpages/MenuFixed";
import i18n from "@/i18n";

export default {
  name: "TermsOfService",
  components: {
    StaticPagesHeader,
    StyledParagraph,
    MenuFixed,
  },
  computed: {
    sections: function () {
      const section_titles = Object.keys(
        i18n.global.getLocaleMessage(this.$i18n.locale).termsOfService,
      ).slice(2);
      const sects = section_titles.map((section) => {
        var obj = {
          title: i18n.global.getLocaleMessage(this.$i18n.locale).termsOfService[
            section
          ].title,
          paragraphs: i18n.global.getLocaleMessage(this.$i18n.locale)
            .termsOfService[section].paragraphs,
          key: section,
        };
        return obj;
      });
      return sects;
    },
    links: function () {
      return this.sections
        .filter((section) => (section.key ? true : false))
        .map((section) => {
          return { name: section.title, ref: section.key };
        });
    },
  },
};
</script>

<style scoped lang="scss">
.terms-of-service {
  .title {
    text-align: center;
    font-family: "Averia Sans Libre", sans-serif;
    font-size: 3em;
    color: $primaryColor;
    margin: 40px 0 40px 0px;
  }

  .download-link {
    text-align: center;
    font-family: "Averia Sans Libre", sans-serif;
    font-size: 1.2em;
    color: $primaryColor;
    margin: 40px 0 40px 0px;
  }
}

.columns {
  display: flex;

  .left-column {
    width: 60%;
  }
}

@media only screen and (max-width: 792px) {
  .columns {
    .left-column {
      width: 100%;
    }
  }
}
</style>
